
import { Box, Button, LinearProgress } from "@material-ui/core";
import CoverPage from "./coverPage";
import DeliverablesTitle from "./DeliverablesTitle";
import Deliverables from "./deliverables";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import moment from "moment";
import { toast } from "react-toastify";
import React from "react";

//test push





const DeliverablesData = ({ work_order, procedure_definistion }: any) => {
      const { authAxios } = useFetchContext();

      const[isLoading, setIsLoading] = React.useState(false);
    
    const downloadIntakeData = async (): Promise<any> => {
        setIsLoading(true);
        try
        {
         const response = await authAxios.get(urls.deliverables.resultViewDataDownload(work_order,procedure_definistion), {
            responseType: "blob",
          });
     
         const downloadUrl = URL.createObjectURL(response.data);
         let a = document.createElement("a");
         a.href = downloadUrl;
         a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
         document.body.appendChild(a);
         a.click();
         setIsLoading(false);
        }catch (err) {
         toast.error(
           `data not available`
         );
         setIsLoading(false);
       }
       };
       if(isLoading){
        return <LinearProgress></LinearProgress>
       }


    return (
        <div>
            
            <Box
                style={{
                    maxWidth: '1000px',
                    margin: 'auto',
                    padding: '50px 0',
                    boxSizing: 'border-box',
                }}
            >
                <Button
                variant="contained"
                color="primary"
                onClick={downloadIntakeData}
                style={{ margin: '20px 0' }}>Download</Button>
                <CoverPage work_order={work_order} procedure_definistion={procedure_definistion} />
            </Box>
            <Box
                style={{
                    maxWidth: '1000px',
                    margin: 'auto',
                    //     padding: '50px 0',
                    boxSizing: 'border-box',
                }}
            >
                <Deliverables work_order={work_order} procedure_definistion={procedure_definistion} />
            </Box>
        </div>
    )
}

export default DeliverablesData;